<template>
 <page>

   <head-nav title="language.new_call_sick">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

<scroll-page>
    <page-padding>
      
      <ui-input title="language.date" type="date" v-bind:val="date" @input="(v)=>{date = v}"></ui-input>
      <ui-input v-if="computeIsParent" title="language.name_parent" type="text" v-bind:val="computeNameParent" :readonly="true"></ui-input>
      <ui-input title="language.name_child" :readonly="true" type="text" v-bind:val="nameChild" @input="(v)=>{nameChild = v}"></ui-input>
    
      <!--<ui-select title="language.name_group" type="text" :select="computeGroups" v-bind:val="groupId" @input="(v)=>{groupId = v}"></ui-select>-->
      
      <ui-select @input="(v)=>{reason=v}" title="language.reason" :select='computeReasons'></ui-select>
      <ui-textarea title="language.description_if_relevant" v-bind:val="description" @input="(v)=>{description = v}"></ui-textarea>
     
    
     
     <ui-select @input="(v)=>{duration=v}" title="language.duration" :select='computeDurations'></ui-select>
     <!--
     <ui-input title="language.telephone" type="number" v-bind:val="tel1" @input="(v)=>{tel1 = v}"></ui-input>
     <ui-input title="language.telephone_alt" type="number" v-bind:val="tel2" @input="(v)=>{tel2 = v}"></ui-input>
    -->
     <ui-input title="language.email" type="email" :readonly="true" v-bind:val="email" @input="(v)=>{email = v}"></ui-input>
      
      <divider title=""/> 
      <button-activate :active="buttonActive" v-on:click.native="confirm()" :title="computeTitle"></button-activate>
     </page-padding>
</scroll-page>  
   </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page.vue';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import PagePadding from '../components/PagePadding.vue';
import ScrollPage from '../components/ScrollPage.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import UiInput from '../components/UiInput.vue';
import UiTextarea from '../components/UiTextarea.vue';
import { modalService } from '../services/ModalService.js';
import i18n from "../language.js";
import { history } from "../services/History.js";
import Divider from '../components/dividers/Divider.vue';
import UiSelect from '../components/UiSelect.vue'
import { absenceSettings } from '../settings/AbsenceSettings.js';
import { helper } from '../services/Helper.js';

export default {
  name: 'add-absence-item-page',
  data:function(){
    return{
      group_id:this.$route.params.group_id,
      date:"",
      nameChild:helper.decodeHtml(this.$route.params.child_name),
      parent_id:this.$route.params.parent_id, /* like literally human parent */
      reason:"",
      description:"",
      duration:"",
      tel1:"",
      tel2:"",
      email:"",
      buttonActive:true,
      absence_reasons:{},
    }
  },
  computed:{
    ...mapState([
       'appSettings','user_schools','groups','group','absences'
       ]),
       computeNameParent(){
         return  this.appSettings.fullname;
       },
       computeIsParent(){
         if(this.appSettings.user_type=="parent"){
           return true
         }else{
           return false;
         }
       },
       computeReasons(){
        return this.absence_reasons;
       },
       computeDurations(){
         return absenceSettings.getDurations();
       },
       computeTitle(){
        if(!this.buttonActive){
          return this.$t('language.working');
        }else{
           return this.$t('language.new_call_sick');
        }
      }
  },
  components: {
    ButtonActivate,
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    UiInput,
    UiTextarea,
    Page,
    ScrollPage,
    Divider,
    UiSelect,
  },
  methods:{
    back(){
     this.$router.push(history.get());
    },
    initForm(){

      var school=this.user_schools.find(school => school.active === 1);
   
      this.email=school.username;
     
      // set date to today;
      var today=new Date();
      
      // set date?
      this.date= this.formatDate(today);

    },
    formatDate(date){
      var year=date.getFullYear();
      var month=(date.getMonth()+101).toString().slice(-2);
      var day=(date.getDate()+100).toString().slice(-2);
      // set date?
      return year+"-"+month+"-"+day;

    },
    isFormComplete(){
      
      if(this.date===""){
          modalService.createAlert(i18n.t('language.form_incomplete_date'))
        return false;
      }

      if(this.nameChild===""){
          modalService.createAlert(i18n.t('language.form_incomplete_name_child'))
        return false;
      }

      if(this.reason===""){
          modalService.createAlert(i18n.t('language.form_incomplete_reason'))
        return false;
      }

      if(this.duration===""){
          modalService.createAlert(i18n.t('language.form_incomplete_duration'))
        return false;
      }
      
      return true
    },
    clearForm(){
      // we done here lets go back
      this.back();
    }, 
    convert_date_nl(us_date){
      var date_us=us_date.split("-"); // yyyy-mm-dd;
      var date_nl=date_us[2]+'-'+date_us[1]+'-'+date_us[0]; // dd-mm-yyyy
      return date_nl;
    },
    confirm(){
    
      if(!this.isFormComplete()){
        return;
      }

     this.buttonActive=false;
     setTimeout(()=>{
       this.callApi();
      },500);

    },
    getAbsenceReasons(){
      this.$store.dispatch('get_absence_reasons',{}).then(
        result=>{
         this.absence_reasons=result.data;
        }
      )
    },
    callApi(){


       var payload={
        parent_id:this.parent_id, /* because a teacher is able to call in sick on behalf of the parent */
        group_id:this.group_id,
        child_name:this.nameChild,
        reason_text:this.reason,
        description:this.description,
        exp_duration:this.duration,
        date:this.convert_date_nl(this.date),
      }



      // gets dummy promise that always resolves
      this.$store.dispatch('add_absence',payload).then(
        ()=>{
          this.buttonActive=true;
          this.clearForm();
        }
      )
      


    },
    
  },
  mounted(){
    this.getAbsenceReasons();
    this.initForm();
    
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.center-text{
  text-align: center;
  margin-bottom:10px;
}
.extra{
  margin-top:10px;
}
img{
  max-width: 60%;
}
.footer{
  margin-top:15px;
  display:flex;
  justify-content: center;
}
.footer .f-img{
  width:80%;
   max-width:250px;
   height:auto;
}
.icon{
  margin-right:5px;
}
</style>
